<template>
  <v-form @submit.prevent="onLogin" class="login-container" ref="form">
    <v-container>
      <v-row align="center" justify="center" class="mb-4">
        <h3>Ingreso</h3>
      </v-row>
      <v-row align="center" justify="center">
        <v-col xs="12" sm="6">
          <v-text-field :rules="[requiredRule]" v-model="username" label="Username" prepend-icon="mdi-account" required
            autocomplete="username"></v-text-field>
        </v-col>
      </v-row>

      <v-row align="center" justify="center">
        <v-col xs="12" sm="6">
          <v-text-field :type="showPass ? 'text' : 'password'" @click:append="showPass = !showPass"
            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'" :rules="[requiredRule]" v-model="password"
            prepend-icon="mdi-lock" label="Password" required autocomplete="current-password"></v-text-field>
        </v-col>
      </v-row>

      <v-row align="center" class="auth-error text-center" justify="center">
        <v-col class="pa-0" cols="5">{{ authenticationError }}</v-col>
      </v-row>

      <v-row class="justify-center">
        <v-btn :loading="isAuthing" type="submit" prepend-icon="mdi-lock" color="primary">Ingresar</v-btn>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {

  data() {
    return {
      username: '',
      password: '',
      requiredRule: value => !!value || 'Reqerido.',
      showPass: false
    }
  },
  methods: {
    ...mapActions('auth', [
      'login'
    ]),
    async onLogin() {
      const userCred = {
        username: this.username,
        password: this.password
      }
      if (userCred.username && userCred.password) {
        await this.login({ userCred })
      }
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isAuthing',
      'authenticationError',
      'authenticationErrorCode'
    ])
  }
}

</script>

<style lang="scss">
.login-container {
  padding-top: 50px;

  .auth-error {
    color: red;
    margin-bottom: 5px;
    min-height: 25px;
  }

  /* Change the white to any color ;) */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
}
</style>